import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';

import { SummaryItemComponent } from '../../../../shared/components/summary-item/summary-item.component';
import { ContactModel } from '../../models/contact-details.model';
import { CountryNamePipe } from '../../pipes/country-name.pipe';
import { SectionWrapperComponent } from '../containers/section-wrapper-container/section-wrapper-container.component';

@Component({
	selector: 'app-contact-card',
	templateUrl: 'contact-card.component.html',
	imports: [
		SectionWrapperComponent,
		TranslocoModule,
		SummaryItemComponent,
		DatePipe,
		CountryNamePipe,
	],
	standalone: true,
})
export class ContactCardComponent<T extends ContactModel> {
	recordData = input<T>();
}
